/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router";

import { Form, Drawer, Button, Input, Select } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import {
  useFetchEventsByOrderId,
  useFetchOrdersById,
} from "../../../app/orders/mutations";

import { TimeLine } from "./Timeline";
import { Alert } from "./Alert";
import useFetchMaster from "../../../app/maestro/mutations";
import { removeDuplicates } from "../../../utils/utils";
import "../../../styles/orders/ordenes.scss";
import { updateOrder } from "../../../app/orders/api";

import { ProductsTable } from "./ProductsTable";
import { CallForm } from "./CallForm";

const { TextArea } = Input;

export const OrdersDetail = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  let { data: master } = useFetchMaster();

  const [form] = Form.useForm();
  const [isSendForm, setIsSendFrom] = useState(false);
  const [isSendFormError, setIsSendFormError] = useState(false);
  const [isOpenEvents, setIsOpenEvents] = useState(false);
  const [isOpenCallForm, setIsOpenCallForm] = useState(false);
  const [isSendCall, setIsSendCall] = useState(false);

  const [editedProducts, setEditedProducts] = useState(null);
  const [queryEvents, setQueryEvents] = useState(orderId);
  const [_events, setEvents] = useState(orderId);

  const order = useFetchOrdersById(orderId);
  const { events, refetch } = useFetchEventsByOrderId(queryEvents);

  useEffect(() => {
    setEvents(events);
  }, [events]);

  const handleEventsTimeline = (event) => {
    const selectedProduct = {
      posicion: event.posicion,
      id: event.orderId,
    };
    setQueryEvents(selectedProduct);

    setTimeout(() => {
      refetch();
    }, 200);
    setIsOpenEvents(true);
  };

  const onFinish = async (values) => {
    const {
      fechaPedido,
      observaciones,
      direccion,
      municipio,
      barrio,
      cedula,
      nombre,
      telefono,
      telefonoSecundario,
    } = values;

    setIsSendFormError(false);
    setIsSendFrom(false);

    let payload = {
      id: orderId,
      Cabecera: {
        FechaPedido: fechaPedido.replace(/-/g, ""),
        Observaciones: observaciones,
      },
      Direccion: {
        Direccion: direccion,
        Municipio: municipio,
        Barrio: barrio && barrio.length > 0 ? barrio : "",
        Cedula: cedula,
        Nombre: nombre,
        Telefono: `${telefono}|${telefonoSecundario}`,
      },
    };

    if (editedProducts) {
      payload.Detalle = [
        ...editedProducts.map((p) => {
          return {
            Posicion: p.posicion,
            Cantidad: p.cantidad,
            Costo: `${p.costo}|${p.costo}`,
            Tirrilla: p.tirilla,
            Referencia: p.referencia,
            FechaPromesa: p.fechaPromesa,
          };
        }),
      ];
    }

    await updateOrder(payload)
      .then((data) => {
        setIsSendFrom(true);
      })
      .catch(() => setIsSendFormError(true));
  };

  const handleOnConfirm = (selectedProducts) => {
    setEditedProducts(selectedProducts);
    setIsOpenEvents(!isOpenEvents);
    setIsOpenCallForm(!isOpenCallForm)
  };

  const closeCallForm = () => {
    setIsOpenEvents(false);
    setIsOpenCallForm(false);
    window.location.reload();
  }

  const handleCreateCall = (call) => {
    console.log(call);
    setIsSendCall(call);
  }

  const storeCurrentOrder = (order) => {
    localStorage.setItem("CURRENT_ORDER", JSON.stringify(order));
  };

  storeCurrentOrder(order);
  
  return (
    <>
      <div className="orders">
        <div className="orders-header">
          <h2>Órdenes &gt; Crear Llamada / Novedad</h2>
          <div className="orders-actions">
          <Button
            type="default"
            className="btn-secondary"
            onClick={() => navigate(-1)}
          >
            Volver
          </Button>
        </div>
        </div>
        <div className="orders-detail-container">
          <div className="orders-table-header">
            <div className="table-header-messages">
              {isSendForm && (
                <Alert message="Orden enviada exitosamente" type="success" />
              )}
              {isSendFormError && (
                <Alert
                  message="Ocurrió un error actualizando la orden."
                  type="error"
                />
              )}
              {order.mensaje && !isSendForm && (
                <Alert message={order.mensaje} />
              )}
            </div>
          </div>
          <div className="orders-form order-detail-form">
            <Form
              form={form}
              autoComplete="off"
              name="orderDetailForm"
              layout="vertical"
              onFinish={onFinish}
              initialValues={{
                fechaPedido: order.fechaPedido,
                cedula: order.cedula,
                nombre: order.nombre,
                telefono: order.telefono,
                telefonoSecundario: order.telefonoSecundario,
                barrio: order.barrio,
                municipio: order.municipio,
                direccion: order.direccion,
                observaciones: order.observaciones,
              }}
            >
              <div className="form-row">
                <Form.Item
                  name="ordenCompra"
                  rules={[{ required: false, message: "requerido" }]}
                  label="Orden Compra"
                >
                  <Input
                    type="text"
                    placeholder="9283940589298"
                    defaultValue={order.ordenCompra}
                    disabled={true}
                    size="medium"
                    title={order.ordenCompra}
                  />
                </Form.Item>
                <Form.Item
                  name="nombreCliente"
                  rules={[{ required: false, message: "requerido" }]}
                  label="Cliente"
                >
                  <Input
                    type="text"
                    placeholder="Almacenes Flamingo S.A"
                    defaultValue={order.nombreCliente}
                    disabled={true}
                    size="medium"
                    title={order.nombreCliente}
                  />
                </Form.Item>
                <Form.Item
                  name="puntoVenta"
                  rules={[{ required: false, message: "requerido" }]}
                  label="Punto de Venta"
                >
                  <Input
                    type="text"
                    placeholder="AKDC | Alkosto Cedi"
                    defaultValue={order.puntoVenta}
                    disabled={true}
                    size="medium"
                    title={order.puntoVenta}
                  />
                </Form.Item>
                <Form.Item
                  name="solicitante"
                  rules={[{ required: false, message: "requerido" }]}
                  label="Solicitante"
                >
                  <Input
                    type="text"
                    placeholder="9283940589298"
                    defaultValue={order.solicitante}
                    disabled={true}
                    size="medium"
                    title={order.solicitante}
                  />
                </Form.Item>
              </div>
              <div className="form-row">
                <Form.Item
                  name="fechaPedido"
                  rules={[{ required: false, message: "requerido" }]}
                  label="Fecha Pedido"
                >
                  <Input
                    prefix={<CalendarOutlined style={{ fontSize: 24 }} />}
                    type="text"
                    placeholder="dd/mm/yyyy"
                    disabled={true}
                    size="medium"
                    title={order.fechaPedido}
                  />
                </Form.Item>
                <Form.Item
                  name="fechaPromesa"
                  rules={[{ required: false, message: "requerido" }]}
                  label="Fecha Promesa"
                >
                  <Input
                    prefix={<CalendarOutlined style={{ fontSize: 24 }} />}
                    type="text"
                    placeholder="dd/mm/yyyy"
                    defaultValue={order.fechaPromesa}
                    disabled={true}
                    size="medium"
                    title={order.fechaPromesa}
                  />
                </Form.Item>
                <Form.Item></Form.Item>
                <Form.Item></Form.Item>
              </div>
              <h2 className="header-green">Datos del usuario</h2>

              <div className="form-row">
                <Form.Item
                  name="cedula"
                  rules={[{ required: false, message: "requerido" }]}
                  label="Identificación"
                >
                  <Input
                    type="text"
                    disabled={true}
                    size="medium"
                    title={order.cedula}
                  />
                </Form.Item>
                <Form.Item
                  name="nombre"
                  rules={[{ required: false, message: "requerido" }]}
                  label="Nombre Completo"
                >
                  <Input type="text" disabled={true} size="medium" showCount />
                </Form.Item>
                <Form.Item
                  name="telefono"
                  rules={[{ required: false, message: "requerido" }]}
                  label="Teléfono Principal"
                >
                  <Input
                    type="text"
                    disabled={true}
                    size="medium"
                    title={order.telefono}
                  />
                </Form.Item>
                <Form.Item
                  name="telefonoSecundario"
                  rules={[{ required: false, message: "requerido" }]}
                  label="Teléfono Secundario"
                >
                  <Input
                    type="text"
                    disabled={true}
                    size="medium"
                    title={order.telefonoSecundario}
                  />
                </Form.Item>
              </div>
              <div className="form-row">
                <Form.Item
                  name="barrio"
                  rules={[{ required: false, message: "requerido" }]}
                  label="Barrio"
                >
                  <Input
                    type="text"
                    disabled={true}
                    size="medium"
                    title={order.barrio}
                  />
                </Form.Item>
                <Form.Item
                  name="municipio"
                  rules={[{ required: false, message: "requerido" }]}
                  label="Municipio"
                >
                  <Select
                    showSearch
                    size="medium"
                    placeholder="Seleccione"
                    disabled={true}
                    allowClear={true}
                    title={order.municipio}
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? "")
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? "").toLowerCase())
                    }
                    options={[
                      ...removeDuplicates(
                        master?.municipios.map(
                          (m) => `${m.codigoSAP}-${m.municipio}`
                        )
                      ).map((p, index) => {
                        return {
                          value: `${p}`,
                          label: `${p.toUpperCase()}`,
                        };
                      }),
                    ]}
                  />
                </Form.Item>
                <Form.Item
                  style={{ flex: 2 }}
                  name="direccion"
                  rules={[{ required: false, message: "requerido" }]}
                  label="Dirección"
                >
                  <TextArea rows={2} showCount disabled={true} />
                </Form.Item>
              </div>

              <div className="form-row">
                <Form.Item
                  name="observaciones"
                  rules={[{ required: false, message: "requerido" }]}
                  className="text-area-control"
                  label="Observaciones"
                >
                  <TextArea rows={4} showCount disabled={true} />
                </Form.Item>
              </div>
            </Form>
          </div>
          <h2 className="header-green">Productos</h2>
          <div className="orders-table-content">
            {/** <Table columns={columns} dataSource={order.productos} /> **/}

            <ProductsTable
              dataSource={order.productos}
              onHandleEvent={handleEventsTimeline}
              onConfirm={handleOnConfirm}
              enabledToEdit={false}
            />
          </div>
        </div>
      </div>
      <Drawer
        title="Eventos"
        placement="right"
        onClose={() => setIsOpenEvents(!isOpenEvents)}
        open={isOpenEvents}
        mask={false}
        maskClosable={false}
        zIndex={2}
      >
        <TimeLine events={_events} />
      </Drawer>
      <Drawer
        title={
          <div className="drawer--title-form">
            <h2>Registro Llamada / Novedad</h2>
            <div className="drawer--title-form--actions">
              <Button type="default" className="btn-secondary" onClick={closeCallForm}>
                {!!isSendCall ? 'Volver': 'Cancelar'}
                
              </Button>
              <Button
                type="default"
                className="btn-primary"
                form="callForm"
                key="submit"
                htmlType="submit"
                disabled={!!isSendCall}
              >
                Crear Registro
              </Button>
            </div>
          </div>
        }
        placement="left"
        onClose={closeCallForm}
        open={isOpenCallForm}
        maskClosable={false}
        zIndex={1}
        width={600}
      >
        <CallForm order={{ ...order }} products={editedProducts} onCreateCall={handleCreateCall} zones={master?.zonas}/>
      </Drawer>
    </>
  );
};
